import { Templet1 } from "./templates/templet1";

function Page() {
  return (
    <>
      <Templet1
        headline="Efteranslutning för full konnektivitet"
        images="/media/1501/gubbar2.png"
        textbody={[
          <p>
            Efteranslutning till fibernätet är en avgörande pusselbit i strävan
            mot full konnektivitet. Sveriges fibernät har byggts ut i snabb
            takt, och många hushåll och företag är idag uppkopplade. Men
            fortfarande pågår arbetet med att efteransluta de som lämnades
            utanför i första skedet. Denna fas präglas av varierande
            förutsättningar: geografiska, ekonomiska och efterfrågemässiga.
          </p>,
          <p>
            Efteranslutningar är viktiga för att maximera nyttan av redan gjord
            infrastrukturinvestering. Såväl privata som offentliga medel har
            möjliggjort dessa satsningar, men anslutningar i sig räcker inte.
            Det krävs även att kunderna är aktiva användare. Fiber som inte
            används är en outnyttjad resurs.
          </p>,
          <p>
            Samtidigt ser vi att antalet efteranslutningarna över tid planar ut.
            När byggnader som är enkla att nå redan är anslutna, återstår de som
            är dyrare eller där intresset är lågt. I detta läge krävs ett
            strategiskifte från teknikfokus till konnektivitetsfokus.{" "}
          </p>,
          <p>
            Det handlar om att möta digitala behov oavsett teknikval. Trådlösa
            alternativ, som 5G eller fast trådlöst bredband, blir centrala i
            områden där fiber inte är realistiskt. Teknikneutralitet och lokalt
            anpassade lösningar blir därmed viktiga verktyg.{" "}
          </p>,
          <ul>
            <li>
              Byt perspektiv och utgå från funktion och behov, inte teknik.
            </li>
            <li>
              Kartlägg passiva områden och identifiera var efteranslutningar
              avstannat.
            </li>
            <li>
              Stärk samverkan och bygg plattformar för dialog och gemensam
              planering.
            </li>
            <li>
              Öka kunskapen om kapacitetskraven från exempelvis distansarbete
              och e-tjänster.
            </li>
          </ul>,
        ]}
        cardtitle="DOKUMENT"
        carddata={[
          {
            textbody: (
              <a
                // data-udi="umb://media/e501efcd70094cfba173fc3dc2a75b2c"
                href="/media/1501/Bredbandsforum - Efteranslutningar för konnektivitet - 3 juni 2025.pdf"
                title="Bredband för hållbarhet - Slutrapport"
              >
                Efteranslutningar för konnektivitet - Slutrapport (PDF)
              </a>
            ),
          },
        ]}
      />
    </>
  );
}
export default Page;
